const QUESTION_STARTERS = new Set([
	'what',
	"what's",
	'whats',
	'who',
	"who's",
	'whos',
	'where',
	"where's",
	'wheres',
	'when',
	"when's",
	'whens',
	'why',
	"why's",
	'whys',
	'how',
	"how's",
	'hows',
	'which',
	'can',
	'cant',
	"can't",
	'could',
	'couldnt',
	"couldn't",
	'would',
	'wouldnt',
	"wouldn't",
	'should',
	'shouldnt',
	"shouldn't",
	'do',
	'dont',
	"don't",
	'does',
	'doesnt',
	"doesn't",
	'did',
	'didnt',
	"didn't",
	'is',
	'isnt',
	"isn't",
	'are',
	'arent',
	"aren't",
	'was',
	'wasnt',
	"wasn't",
	'were',
	'werent',
	"weren't",
	'will',
	'wont',
	"won't",
	'may',
	'might',
	'must',
	'tell',
	'show',
	'find',
	'give',
	'list',
	'explain',
	'summarize',
	'summarise',
	'describe',
	'compare',
]);

/**
 * Heuristic: does this text read like a question/command rather than a search term?
 * Used to gate live-filter behavior — when asking, the list stops updating and the
 * input becomes a chat prompt instead.
 *
 * Triggers on a trailing `?` or a recognised question/imperative first word.
 * Conservative on purpose: short search queries like "kitchen warranty" stay non-asking.
 */
const ASKING_WORD_THRESHOLD = 6;

export const isAsking = (text: string): boolean => {
	const trimmed = text.trim();
	if (!trimmed) return false;
	if (trimmed.endsWith('?')) return true;
	const words = trimmed.toLowerCase().split(/\s+/);
	if (QUESTION_STARTERS.has(words[0])) return true;
	if (words.length >= ASKING_WORD_THRESHOLD) return true;
	return false;
};
